export const kCountClass = "count"
export const kCountType = "Count"
export const kCountPrefix = "ADRN"
export const kCountLabelKey = "DG.Inspector.graphCount"
export const kPercentClass = "percent"
export const kPercentType = "Percent"
export const kPercentLabelKey = "DG.Inspector.graphPercent"
